import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { AccountUsersEffects } from './+state/account-users.effects';
import { accountUsersReducer } from './+state/account-users.reducer';
import { ACCOUNT_USERS_FEATURE_KEY } from './+state/account-users.state';
import { AccountUsersRepository } from './account-users.repository';
import { LOCALIZATION_SCOPE } from './constants';
import { AccountUserFullNamePipe } from './pipes/account-user-full-name.pipe';

@NgModule({
  imports: [
    CommonModule,
    CommonLocalizationModule.forFeature(LOCALIZATION_SCOPE),
    StoreModule.forFeature(ACCOUNT_USERS_FEATURE_KEY, accountUsersReducer),
    EffectsModule.forFeature([AccountUsersEffects])
  ],
  declarations: [AccountUserFullNamePipe],
  providers: [AccountUsersRepository],
  exports: [AccountUserFullNamePipe]
})
export class AccountUsersModule {}
